import { render, staticRenderFns } from "./LatestCards.vue?vue&type=template&id=4a8591b3&"
import script from "./LatestCards.vue?vue&type=script&lang=js&"
export * from "./LatestCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports